import { isWithIsMasterBlockRoot } from 'common/utils/entityUtils'
import { EntitiesType } from 'src/shared/types/server-page-interface'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

/* NOTE: for fixing https://app.shortcut.com/systeme/story/51271/adding-masterblock-creates-duplicates-on-page-header-and-footer
 * removing isMasterBlockRoot for all entities of masterBlock except root
 *
 * ------CASE---------
 * entities: {
 *  bodyEntity: {
 *    childIds: [masterBlockEntity1]
 *  },
 *  masterBlockEntity1: {
 *    parentId: bodyEntity,
 *    childIds: [masterBlockEntity2],
 *    masterBlockId: 1,
 *    isMasterBlockRoot: true
 *  },
 *  masterBlockEntity2: {
 *    parentId: masterBlockEntity1,
 *    childIds: [],
 *    masterBlockId: 1,
 *    isMasterBlockRoot: true
 *  }
 * }
 * masterBlockEntity2 should not have isMasterBlockRoot=true, because masterBlockEntity1 is root
 * of the master block, therefore we have to remove isMasterBlockRoot from masterBlockEntity2
 * --------------------
 */
export default function fixIsMasterBlockRootCommandForClient(
  originalEntities: EntitiesType,
): [EntitiesType, boolean] {
  let needChangeContent = false
  const originalEntitiesValues = Object.values(originalEntities)
  const masterBlocksEntities: Record<MasterBlockIdType, EntityIdType[]> = {}

  // biome-ignore lint/complexity/noForEach: <explanation>
  originalEntitiesValues.forEach(entity => {
    if ('masterBlockId' in entity && entity.masterBlockId) {
      if (entity.masterBlockId in masterBlocksEntities) {
        masterBlocksEntities[entity.masterBlockId].push(entity.id)
      } else {
        masterBlocksEntities[entity.masterBlockId] = [entity.id]
      }
    }
  })

  // biome-ignore lint/complexity/noForEach: <explanation>
  Object.values(masterBlocksEntities).forEach(masterBlockEntitiesIds => {
    // biome-ignore lint/complexity/noForEach: <explanation>
    masterBlockEntitiesIds.forEach(masterBlockEntityId => {
      if (isWithIsMasterBlockRoot(originalEntities[masterBlockEntityId])) {
        const shouldNotHaveIsMasterBlockRoot = masterBlockEntitiesIds.some(
          masterBlockEntityId2 =>
            'parentId' in originalEntities[masterBlockEntityId] &&
            originalEntities[masterBlockEntityId].parentId ===
              masterBlockEntityId2,
        )
        if (shouldNotHaveIsMasterBlockRoot) {
          needChangeContent = true
          delete originalEntities[masterBlockEntityId].isMasterBlockRoot
        }
      }
    })
  })

  return [originalEntities, needChangeContent]
}
